import React, {Fragment, useEffect, useLayoutEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  activeAction,
  selectUserGroup,
  changeUsertSearch,
} from "Stores/actions";
import { userColumn } from "Constants/TableColumns";
import Translator from "Languages/Utility/Translator";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { Grid } from "@material-ui/core";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import cellEditFactory from "react-bootstrap-table2-editor";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import { useTranslation } from 'react-i18next';
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

function UserTable() {
  const { t } = useTranslation();
  const {
    userGroupData,
    userGroupDataPagination,
    userGroupDataSearch,
  } = useSelector((state) => ({
    userGroupData: state.user.userGroupData,
    userGroupDataSearch: state.user.userGroupDataSearch,
    userGroupDataPagination: state.user.userGroupDataPagination,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(userGroupDataPagination.Limit);
  const [currentPage, setCurrentPage] = useState(userGroupDataPagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(userGroupData);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (userGroupData) {
      setTblData(userGroupData);
      setTotal(userGroupDataPagination.Total);
    }
  }, [userGroupData, userGroupDataPagination]);

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  }, [userGroupDataSearch]);

  const BeforeSaveCell = async (oldValue, newValue, row, column) => {
    if (column.dataField === "Active") {
      if (oldValue !== newValue) {
        try {
          setLoading(true);
          const data = {
            Active: newValue,
            UserName: row.UserName,
            KeyGroup: read("groupKey"),
            KeyUs: read("userKey"),
          };
          await dispatch(activeAction(data));
          const params = {
            Key: read("groupKey"),
            KeyUs: read("userKey"),
            Limit: userGroupDataPagination.Limit,
            Page: userGroupDataPagination.Page,
            Name: userGroupDataSearch?.Name,
          };
          await dispatch(selectUserGroup(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    }
  };

  const setValue = (name, value) => {
    dispatch(changeUsertSearch({ Name: value }));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const params = {
        Key: read("groupKey"),
        KeyUs: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
        Name: convertToEnglishNumber(userGroupDataSearch?.Name),
      };
      await dispatch(selectUserGroup(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeUsertSearch({ Name: "" }));
    try {
      setLoading(true);
      const params = {
        Key: read("groupKey"),
        KeyUs: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
      };
      await dispatch(selectUserGroup(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          Key: read("groupKey"),
          KeyUs: read("userKey"),
          Limit: sizePerPage,
          Page: page,
          Name: userGroupDataSearch?.Name,
        };
        await dispatch(selectUserGroup(params));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container >
        <Grid item md={3} sm={6} xs={12} className="m-3">
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={userGroupDataSearch ? userGroupDataSearch?.Name : ""}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      <RemoteTable
        data={tblData}
        columns={userColumn}
        loading={loading}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          beforeSaveCell: (oldValue, newValue, row, column, done) =>
            BeforeSaveCell(oldValue, newValue, row, column, done),
        })}
        title={<Translator id="list_karbaran" />}
      />
    </Fragment>
  );
}

export default UserTable;
